<template>
  <multiple_form
    :forms="forms"
    :edit="props.canEdit"
    :editData="props.editData"
    @submit="handelSubmit"
  />
</template>
<script setup>
  import { ref, defineProps, defineEmits, computed } from 'vue'
  import { message } from 'ant-design-vue'
  import {
    createData,
    updateData,
  } from '@/api/car_application/car_registration'
  import multiple_form from '@/components/multiple_form'
  import { areaTypeConst } from '@/utils/common'
  import { constantToOptions } from '@/utils/format'

  //初始化
  const props = defineProps({
    isEdit: Boolean,
    canEdit: Boolean,
    editData: Object,
    data: Array,
    idField: String,
  })
  const emit = defineEmits(['submit'])

  //编辑、新增的表单
  const forms = computed(() => [
    {
      name: '基础信息',
      id: 'applicant_information',
      formItem: [
        {
          type: 'select',
          field: 'visit_area',
          label: '申请园区',
          // storeOptions: 'areaType',
          options: constantToOptions(areaTypeConst),
        },
        {
          type: 'input',
          field: 'visitor_company',
          label: '来访单位',
        },
        {
          type: 'input',
          field: 'license_plate',
          label: '车牌号码',
        },

        {
          type: 'select',
          field: 'license_plate_color',
          storeOptions: 'plateColorType',
          getName: true,
          label: '车牌颜色',
          required: false,
        },
        {
          type: 'dateRange',
          startField: 'begin_time',
          endField: 'end_time',
          label: '来访时间',
        },
        {
          type: 'input',
          field: 'phone',
          label: '手机号码',
        },
      ],
    },
    {
      name: '相关文件',
      id: 'applicant_file',
      formItem: [
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'registry_img',
          label: '车辆信息登记表',
          required: false,
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'business_license',
          label: '营业执照复印件',
          required: false,
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'company_road_transport_img',
          label: '公司道路运输经营许可证复印件',
          number: 20,
          required: false,
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'legal_person_img',
          label: '法人身份证',
          number: 20,
          required: false,
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'driver_info_img',
          label: '驾驶员的驾驶证、身份证及从业资格证',
          number: 20,
          required: false,
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'supercargo_info_img',
          label: '押运员的身份证以及业资格证',
          number: 20,
          required: false,
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'vehicle_driving_permit_img',
          label: '行驶证（车头、挂车）',
          number: 20,
          required: false,
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'road_transport_img',
          label: '道路运输证（车头、挂车）',
          number: 20,
          required: false,
        },

        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'compulsory_insurance_img',
          label: '强制险',
          number: 20,
          required: false,
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'commercial_insurance_img',
          label: '商业险',
          number: 20,
          required: false,
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'carrier_liability_insurance_img',
          label: '道路危险货物承运人责任保险',
          number: 20,
          required: false,
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'report_or_instruction_img',
          label: '罐检报告或产品图片、产品标签图片以及车尾照片',
          number: 20,
          required: false,
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'letter_commitment_img',
          label: '重点运输单位承诺书',
          number: 20,
          required: false,
        },
        {
          // type: 'fileUpload',
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'gps_instruction_img',
          label: '	GPS接入文档',
          number: 20,
          required: false,
        },
      ],
    },
  ])

  async function handelSubmit(data) {
    const ajaxFn = props.isEdit ? updateData : createData
    const messageText = props.isEdit ? '编辑' : '创建'
    const id = props.isEdit
      ? { [props.idField]: props.editData[props.idField] }
      : {}
    const res = await ajaxFn({ ...data, ...id })
    if (res.success) {
      message.success(messageText + '成功！')
      emit('submit')
    } else {
      message.warn(messageText + '错误：', res.message)
    }
  }
</script>
